module.exports = __webpack_public_path__ + "img/logo-bingo.6e3c6b29.png";